import { fontWeight } from '@devrangex/rui'
import { css } from '@emotion/react'

import { RankTableRow } from './RankTableRow'
import { useRankerList } from './useFetchRank'


const tableStyle = css`
  width: 100%;
  border-spacing: 0;
  /* table-layout: fixed; */

  & thead {
    & th {
      font-size: 1vw;
      text-align: left;
      font-weight: ${fontWeight.medium};
      padding: 1.2vh 0.5vw;
      color: #696e76;
      border-bottom: 1px solid #1b1e22;

      &.number {
        text-align: center;
      }

      &:nth-of-type(1) {
        min-width: 6vw;
        max-width: 8vw;
      }
      &:nth-of-type(2) {
        min-width: 16vw;
      }
      &:nth-of-type(3) {
        min-width: 20vw;
      }
      &:nth-of-type(4) {
        width: 100%;
      }
      &:nth-of-type(5) {
        min-width: 10vw;
      }

      @media screen and (orientation: portrait) {
        font-size: 1.8vw;
        padding: 1.2vh 1vw;

        &:nth-of-type(1) {
          min-width: 6vw;
          max-width: 8vw;
        }
        &:nth-of-type(2) {
          min-width: 26vw;
        }
        &:nth-of-type(3) {
          min-width: 20vw;
        }
        &:nth-of-type(4) {
          width: 100%;
        }
        &:nth-of-type(5) {
          min-width: 16vw;
        }
      }
    }
  }
`

const animationDelay = (delay: number) => css`
  animation-delay: ${delay}s;
`

export default function RankTable() {
  const rankers = useRankerList()

  return (
    <table css={tableStyle}>
      <thead>
        <tr>
          <th className='number'>랭킹</th>
          <th></th>
          <th>닉네임</th>
          <th className='number'>총 점수(평균)</th>
          <th>매장명</th>
        </tr>
      </thead>
      <tbody>
        {rankers.map((ranker, idx) => (
          <RankTableRow
            key={`head:${idx}`}
            tuple={[
              ranker.rank,
              ranker.rank,
              ranker.nickName,
              ranker.scoreWithAvg,
              ranker.shopName,
            ]}
            nation={ranker.nation}
            cssProps={animationDelay(idx * 0.3)}
          />
        ))}
      </tbody>
    </table>
  )
}
